import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostTemplateCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostTemplateCommandService],
  exports: []
})
export class PostTemplateCommandServiceModule { }
